
import Select, { components } from "react-select";
import React, { useState } from "react";
import { DropdownIndicator } from "../../../../lib/helpers";

export const MultiSelectGroupDropdown = ({ id, isMulti, readOnly, error, onChange, onClick, onTouchStart, value, label, active, options, menuIsOpen, isStorybook }) => {

    const { ValueContainer } = components;

    let selected_value = null;

    if (isMulti) {
        selected_value = [];
        value.forEach(function (item) {
            selected_value.push({ "label": item, "value": item });
        })
    } else {
        if (value) {
            selected_value = {
                label: value,
                value: value
            };
        }
    }


    const InputOption = ({
        getStyles,
        isDisabled,
        isFocused,
        isSelected,
        children,
        innerProps,
        ...rest
    }) => {
        const [isActive, setIsActive] = useState(false);
        const onMouseDown = () => setIsActive(true);
        const onMouseUp = () => setIsActive(false);
        const onMouseLeave = () => setIsActive(false);

        // styles
        let bg = "transparent";
        if (isFocused) bg = "#eee";
        if (isActive) bg = "#B2D4FF";

        const style = {
            alignItems: "center",
            backgroundColor: bg,
            color: "inherit",
            display: "flex "
        };

        // prop assignment
        const props = {
            ...innerProps,
            onMouseDown,
            onMouseUp,
            onMouseLeave,
            style
        };

        return (
            <components.Option
                {...rest}
                isDisabled={isDisabled}
                isFocused={isFocused}
                isSelected={isSelected}
                getStyles={getStyles}
                innerProps={props}
            >
                <span className={"checkbox-wrap checkbox-label"}>
                    <input className={'option-input-checked'} type="checkbox" checked={isSelected} /><span className={"checkmark"}></span></span>&nbsp;
                <span className={'group-checkbox-label'}>{children}</span>

            </components.Option>
        );
    };

    const formatGroupLabel = data => (
        <div className={"option-label-heading"}>
            <span>{data.label}</span>
        </div>
    );

    const CustomValueContainer = ({ children, ...props }) => {
        let [values, input] = children;
        if (Array.isArray(values)) {
            const val = (i = Number) => values[i].props.children;
            const { length } = values;
            switch (length) {
                case 1:
                    values = `${val(0)} `;
                    break;
                default:

                    const otherCount = length - 1;
                    values = `${val(0).length > 28 ? val(0).substring(0, 27) + "..." : val(0)}, +${otherCount} more`;
                    break;
            }
        }
        return (
            <components.ValueContainer {...props}>
                {values}
                {input}
            </components.ValueContainer>
        );
    };

    return (
        <div onClick={onClick} onTouchStart={onTouchStart} className={` dropdown-container form-group input-field mb-0 ${readOnly ? "read-only-dropdown" : ""} ${error ? "field-error" : ""} ${((value != '' && value != null) || active == true) ? 'focused' : ''} ${(active == true) ? 'active' : ''}`} id={id} >
            <div className={`input-position-relative  dropdown-field country-dropdown multiselect-dropdown multiselectgroup-dropdown`}>
                {isStorybook ?

                    <>
                        <span className={""}>
                            <Select
                                isMulti={true}
                                isClearable={false}
                                isSearchable={false}
                                isDisabled={false}
                                hideSelectedOptions={false}
                                closeMenuOnSelect={false}
                                defaultMenuIsOpen={false}
                                name="countries"
                                options={options}
                                onChange={onChange}
                                placeholder={label}
                                value={selected_value}
                                components={{
                                    Option: InputOption,
                                    ValueContainer: CustomValueContainer, DropdownIndicator
                                }}
                                styles={{
                                    placeholder: (provided, state) => ({
                                        ...provided,
                                        display: state.selectProps.inputValue ? "none" : "block",
                                    })
                                }}
                                formatGroupLabel={formatGroupLabel}
                                classNamePrefix="userq-select"
                            />
                        </span>
                    </>
                    :
                    <>

                        <span className={"none-for-mobile "}>
                            <Select
                                isMulti={true}
                                isClearable={false}
                                isSearchable={false}
                                isDisabled={false}
                                hideSelectedOptions={false}
                                closeMenuOnSelect={false}
                                menuIsOpen={(menuIsOpen) ? true : false}
                                defaultMenuIsOpen={false}
                                name="countries"
                                options={options}
                                onChange={onChange}
                                placeholder={label}
                                value={selected_value}
                                components={{
                                    Option: InputOption,
                                    ValueContainer: CustomValueContainer, DropdownIndicator
                                }}
                                styles={{
                                    placeholder: (provided, state) => ({
                                        ...provided,
                                        display: state.selectProps.inputValue ? "none" : "block",
                                    })
                                }}
                                formatGroupLabel={formatGroupLabel}
                                classNamePrefix="userq-select"
                            />
                        </span>

                        <span className={"none-for-desktop"}>
                            <Select
                                isMulti={true}
                                isClearable={false}
                                isSearchable={false}
                                isDisabled={false}
                                hideSelectedOptions={false}
                                closeMenuOnSelect={false}
                                defaultMenuIsOpen={false}
                                name="countries"
                                options={options}
                                onChange={onChange}
                                placeholder={label}
                                value={selected_value}
                                components={{
                                    Option: InputOption,
                                    ValueContainer: CustomValueContainer, DropdownIndicator
                                }}
                                styles={{
                                    placeholder: (provided, state) => ({
                                        ...provided,
                                        display: state.selectProps.inputValue ? "none" : "block",
                                    })
                                }}
                                formatGroupLabel={formatGroupLabel}
                                classNamePrefix="userq-select"
                            />
                        </span>

                    </>
                }

                <label className="control-label body-text body-text-2" htmlFor={id}>

                    {label}
                </label>


            </div>
            {error != null && (
                <span className="caption">
                    {error}
                </span>
            )}
        </div>
    );
}

MultiSelectGroupDropdown.defaultProps = {
    onChange: undefined,
    inactive: false,
    focussed: false,
    open: false,
    type: "country",
    isMulti: true,
    menuIsOpen: false,
};
